import { get } from "lodash";
import { KOSTENTRAEGER } from "src/lib/constants/constant";
import MittelabrufSchema from "src/lib/paths/mittelabruf_FULL_Paths.json";
import NachweisPositionSchema from "src/lib/paths/nachweisposition_FULL_Paths.json";
import { getVerbundPartnerName } from "src/pages/private/online-antrag/application-helper-function/AppHelperfunctions";

const MA_P = MittelabrufSchema.attributes;
const NP_P = NachweisPositionSchema.attributes;

export type LoeweMittelabrufOrganization = {
  id: number | string;
  label: string;
  kostentraeger: string;
};

export const getLoeweMittelabrufOrganizations = (
  application: any,
  applicantOrganizationId?: number | string,
): LoeweMittelabrufOrganization[] => {
  const organizations: LoeweMittelabrufOrganization[] = [];
  const applicantName = get(
    application,
    MA_P.Foerderantrag.schema.attributes
      .Antragstellende_Organisa_0074063902_licher_Name_Der_Organisation.path,
    "Antragsteller",
  );

  if (
    applicantOrganizationId !== undefined &&
    applicantOrganizationId !== null
  ) {
    organizations.push({
      id: applicantOrganizationId,
      label: applicantName,
      kostentraeger: KOSTENTRAEGER.Antragsteller,
    });
  }

  get(
    application,
    MA_P.Foerderantrag.schema.attributes.Verbundpartner.path,
    [],
  ).forEach((partner: any, index: number) => {
    const organizationId = get(partner, "Verbundpartner.id");
    if (organizationId === undefined || organizationId === null) return;

    organizations.push({
      id: organizationId,
      label: getVerbundPartnerName(partner, index),
      kostentraeger: KOSTENTRAEGER.Verbundpartner,
    });
  });

  return organizations;
};

export const getMittelabrufPositionOrganizationId = (
  position: any,
): number | string | undefined => {
  const organization = get(
    position,
    NP_P.Allgemein_Unternehmen_Institution.path,
  );
  return get(organization, "id", organization);
};

export const belongsToMittelabrufOrganization = (
  position: any,
  organizationId: number | string,
  kostentraeger?: string,
): boolean => {
  const positionOrganizationId = getMittelabrufPositionOrganizationId(position);
  if (
    positionOrganizationId !== undefined &&
    positionOrganizationId !== null &&
    positionOrganizationId !== ""
  ) {
    return String(positionOrganizationId) === String(organizationId);
  }

  return (
    kostentraeger === KOSTENTRAEGER.Antragsteller &&
    get(position, NP_P.Allgemein_Kostentraeger.path) ===
      KOSTENTRAEGER.Antragsteller
  );
};
